module.exports = __webpack_public_path__ + "img/reference-promtex.d64f493e.webp";